/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-04
 */

import React from "react";
import {connect} from "dva";
import {templateConfig, reduxTemplateConfig} from "./config";

import {framework_tool, component_tool} from '../../../tool';
import {WizTableForm} from "../../common";

let {WizContainer, WizReduxTemplate} = framework_tool;
let { WizBrowserExport,WizModal} = component_tool;
const _getValue = (type, key) => {
  const values = {
    status: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
    face: {
      1: '是',
      0: '否',
    },
    scoreRule: {
      0: '最高分',
      1: '平均分',
    },
    examType: {
      '0': '独立考试',
      '1': '课程考试',
      '0,1': '独立考试、课程考试',
      '1,0': '独立考试、课程考试'
    }
  }
  return values[type][key]
}

class Exam extends WizContainer {
  componentName = 'exam';

  constructor(props) {
    super(props);
    this.state = {
      addByTempVisible: false
    }
    this.initialValue = {};
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'left',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '考试名称',
        field: 'title',
        width: 30,
      },
      {
        headerName: '考试分类',
        field: 'categoryType',
        width: 20,
      },
      {
        headerName: '考试类型',
        field: 'examType',
        width: 20,
      },
      {
        headerName: '考试受众',
        field: 'targetScope',
        width: 20,
      },
      {
        headerName: '管理权限',
        field: 'managerTargetScope',
        width: 20,
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 25,
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 25,
      },
      {
        headerName: '状态',
        field: 'status',
        width: 20
      },
      // {
      //   headerName: '身份验证',
      //   field: 'face',
      //   width: 20
      // },
      {
        headerName: '考试时长(分钟)',
        field: 'limitMinutes',
        width: 20,
      },
      {
        headerName: '允许重复考试次数',
        field: 'count',
        width: 20,
      },
      {
        headerName: '总分',
        field: 'totalScore',
        width: 20,
      },
      {
        headerName: '通过分数',
        field: 'passScore',
        width: 20,
      },
      {
        headerName: '成绩规则',
        field: 'scoreRule',
        width: 20,
      },
    ]
    if (o['success']) {
      let data = Object.assign([], o['data'])
      data.forEach((val, index) => {
        val['status'] = _getValue('status', val['status'])
        val['face'] = _getValue('face', val['face'])
        val['scoreRule'] = _getValue('scoreRule', val['scoreRule'])
        val['examType'] = _getValue('examType', val['examType'])
      })
      WizBrowserExport({
        title: '考试安排管理信息',
        sheetName: '考试安排管理信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '考试安排管理信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleExamByTemp(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }
  //选择模版后下一步
  _addExamByTempSubmit = (obj, e) => {
    let examList = [];
    if (obj && obj['valueRows'] && obj['valueRows'].length > 0) {
      obj['valueRows'].forEach(key => {
        let exam = {
          ...key,
          channelType: "temp"
        };
        examList.push(exam)
      });
      if (examList && examList.length) {
        this.jumpPage("push","/online/exam/examDetailAdd",{...examList[0]});
      }
    }
    this.setState({
      addByTempVisible: false,
    });
  }
  _onCancel= (e) =>{
    this.setState({
      addByTempVisible: false,
    });
  };

  _render() {
    const {surveyLoading} = this.props;
    let initialValue = this.initialValue;
    const {addByTempVisible} = this.state;
    const {id} = initialValue;
    let _templateConfig = templateConfig({
      valueRows: this.valueRows,
      self:this,
      _btnFun: (e) => {
        this.setState({
          addByTempVisible: true
        })
      }
    })
    let _reduxTemplateCofig = reduxTemplateConfig({
      id: id,
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile,
        addByTemp: this._handleExamByTemp,
        publish:(nextProps, nextState, key) =>{
          let o = nextProps[key]
          if (o['success']) {
            wizNotice.success(o['msg']);
            let bizIds = o['data']
            if(bizIds){
              if(bizIds>0){
              WizModal.confirm({
                title: '注意', content:"消息通知内容有变更，是否重新发送消息通知",cancelText:"否",okText:"是",
                onOk: () => {
                  this.doAction({
                    path:  "notice/sendNotice",
                    payload: {
                      key: "sendNoticeKey",
                      apiParams: {
                        bizId: bizIds,
                        bizType: 1,
                        resend:true
                      },
                    },
                  })
                },
                onCancel: () => {
                  this.doActions([
                    {
                      path:  "notice/sendNotice",
                      payload: {
                        key: "sendNoticeKey",
                        apiParams: {
                          bizId: bizIds,
                          bizType: 1,
                          resend:false
                        },
                      },
                    },
                  ]);
                }
              });
            }else{
              this.doActions([
                {
                  path:  "notice/sendNotice",
                  payload: {
                    key: "sendNoticeKey",
                    apiParams: {
                      bizId: 0-bizIds,
                      bizType: 1,
                      resend:false
                    },
                  },
                },
              ]);
            }
            }
            return true;
          } else {
            wizNotice.error(o['msg']);
            return false;
          }
        },
        close:this._handleExamByTemp,
        delExam: this._handleExamByTemp,
        changeExamFaceAuth:this._handleExamByTemp,
      },
    });
    return <>
      <WizReduxTemplate {..._reduxTemplateCofig} />
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(Exam);
